import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatCheckboxChange, MatDialogRef, MatSelectChange } from '@angular/material';
import { Airport } from '../models/airport.model';
import { CloseDialog } from '../../shared/dialog-close/dialog-close';
import { FormGroup, FormControl, Validators } from '../../../../node_modules/@angular/forms';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { Business } from '../../business/models/business.model';
import { NewBusiness } from '../../business/models/new-business-model';
import { BusinessTag } from '../../business/models/business-tag.model';
import { AuthService } from '../../auth/auth/auth.service';
import { Router } from '@angular/router';
import { AirportService } from '../airport.service';
import { UserService } from '../../shared/user/user.service';
import { Country } from '../../business/models/country.model';
import { State } from '../../business/models/state.model';
import { CountriesService } from '../../shared/services/countries.service';
import { Address } from '../../shared/models/address.model';
import { formatPhoneString, undoPhoneFormat } from '../../util/phone';
import { AbstractControl, ValidationErrors } from '@angular/forms';


@Component({
  selector: 'app-user-submit-new-business',
  templateUrl: './user-submit-new-business.component.html',
  styleUrls: ['./user-submit-new-business.component.scss']
})
export class UserSubmitNewBusinessComponent implements OnInit {

  airport: Airport;
  facilityType: string;
  facilityTitleType: string;
  formGroup: FormGroup;
  businessTags: BusinessTag[];
  isLoading = true;
  businessPanelText = 'Expand Business Address Form';
  mailingPanelText = 'Expand Mailing Address Form';
  businessPanelIsActive = true;
  countries: Country[];
  postalCodePlaceHolder = '';
  states: State [] = new Array<State>();
  statesMailing: State [] = new Array<State>();
  business: Business;


  constructor(private _dialogRef: MatDialogRef<UserSubmitNewBusinessComponent>,
              @Inject(MAT_DIALOG_DATA) public data,
              private _businessManagerService: BusinessManagerService,
              private _auth: AuthService,
              private _router: Router,
              private _airportService: AirportService,
              private _userService: UserService,
              private countriesService: CountriesService) {
    this.airport = data.airport;
    this.facilityType = data.facilityType;
    this.facilityTitleType = data.facilityType;
    if (data.facilityType === 'business') {
      this.facilityTitleType = 'Business';
    }
    this.business = new Business();
    this.business.address = new Address();
    this.business.address.country = 'US';
  }

  async ngOnInit() {
    if (!this._auth.authenticated || !this._auth.endUser) {
      this._auth.redirectToLogin();
      return;
    }
    if (!this.business.mailingAddress) {
      this.business.mailingAddress = new Address();
    }
    this.formGroup = new FormGroup({
      terms: new FormControl(null, [Validators.required]),
      name: new FormControl(this.business.name, [Validators.required, Validators.maxLength(50)]),
      street1: new FormControl(this.business.address.street1, [Validators.required, Validators.maxLength(80)]),
      street2: new FormControl(this.business.address.street2, [Validators.maxLength(80)]),
      stateProvince: new FormControl(''),
      postalCode: new FormControl(this.business.address.postalCode),
      city: new FormControl(this.business.address.city, [Validators.required, Validators.maxLength(40)]),
      country: new FormControl(this.business.address.country, [Validators.required]),
      addressSame: new FormControl(true),
      mailingStreet1: new FormControl(this.business.mailingAddress.street1, [Validators.maxLength(80)]),
      mailingStreet2: new FormControl(this.business.mailingAddress.street2, [Validators.maxLength(80)]),
      mailingStateProvince: new FormControl('', [Validators.maxLength(30)]),
      mailingPostalCode: new FormControl(this.business.mailingAddress.postalCode, [Validators.maxLength(9)]),
      mailingCity: new FormControl(this.business.mailingAddress.city, Validators.maxLength(40)),
      mailingCountry: new FormControl(this.business.mailingAddress.country),
      phone: new FormControl(formatPhoneString(this.business.phone), [Validators.pattern('^([(]\\d{3}[)]\\s\\d{3}[-]\\d{4})$')]),
      fax: new FormControl(formatPhoneString(this.business.fax), [Validators.pattern('^([(]\\d{3}[)]\\s\\d{3}[-]\\d{4})$')]),
      webAddress: new FormControl(this.business.webAddress, [Validators.maxLength(100)]),
      email: new FormControl(this.business.email, [Validators.maxLength(55), this.customEmailValidator]),
      locationOnField: new FormControl(this.business.locationOnField),
      isLocatedOnField: new FormControl(true),
      locationDesc: new FormControl(this.business.locationDesc, [Validators.maxLength(50)])
    });
    try {
      this.countries = await this.countriesService.getCountries();
    } catch (e) {
      this._dialogRef.close({cancelBtnClicked: false, success: false});
    }
    if (this.business.address.country) {
      try {
        this.states = await this.countriesService.getStates(this.business.address.country);
        this.states.length ? this.formGroup.controls['stateProvince'].setValidators([Validators.required, Validators.maxLength(50)]) :
          this.formGroup.controls['stateProvince'].setValidators([Validators.maxLength(30)]);
        if (this.business.mailingAddress && this.business.mailingAddress.country) {
          this.statesMailing = await this.countriesService.getStates(this.business.mailingAddress.country);
        }
      } catch (e) {
        this._dialogRef.close({cancelBtnClicked: false, success: false});
      }
    }
    this.isLoading = false;
    this.formGroup.patchValue({country: this.business.address.country || 'US'});
    this.formGroup.patchValue({mailingCountry: this.business.mailingAddress.country || 'US'});
    this.formGroup.patchValue({stateProvince: this.business.address.stateProvince || ''});
    this.formGroup.patchValue({mailingStateProvince: this.business.mailingAddress.stateProvince || ''});
    if (this._compareAddress()) {
      this.formGroup.patchValue({addressSame: true});
      this._changeMailingFieldsState(true);
    }
    if (!this.business.locationOnField) {
      this.formGroup.patchValue({isLocatedOnField: false, locationOnField: ''});
    }
    this._setPostalCodeValidation(this.business.address.country);


    this._dialogRef.backdropClick().subscribe(() => {
      const CLOSE_DIALOG = new CloseDialog();
      CLOSE_DIALOG.cancelButtonClicked = true;
      this._dialogRef.close(CLOSE_DIALOG);
    });
  }

  private customEmailValidator(control: AbstractControl): ValidationErrors {
    if (!control.value) {
      return null;
    }

    return Validators.email(control);
  }

  /**
   * triggered when value inside countries dropdown changes; event.value contains two digit country code.
   * @param {MatSelectChange} event
   * @return {Promise<void>}
   */
  async countryChange(event: MatSelectChange) {
    // if value property is empty return
    if (!event.value) { return; }
    if (event.source.id.toString() === '1') {
      await this._setAddressForm(event.value);
      if (event.value === this.business.address.country) {
        this.formGroup.patchValue({stateProvince: this.business.address.stateProvince || ''});
      }
    } else if (event.source.id.toString() === '2') {
      await this._setMailingAddressForm(event.value);
      if (event.value === this.business.mailingAddress.country) {
        this.formGroup.patchValue({mailingStateProvince: this.business.mailingAddress.stateProvince || ''});
      }
    }
  }

  /**
   *  returns true if {Business} address and mailing address are the same.
   * @return {boolean}
   * @private
   */
  _compareAddress(): boolean {
    return (
      this.business.address.street1 === this.business.mailingAddress.street1 &&
      this.business.address.street2 === this.business.mailingAddress.street2 &&
      this.business.address.city === this.business.mailingAddress.city &&
      this.business.address.stateProvince === this.business.mailingAddress.stateProvince &&
      this.business.address.country === this.business.mailingAddress.country
    );
  }

  /**
   * Function toggles mailing address fields in UI betweened disabled and enabled based on boolean flag passed in.
   * @param {boolean} disabled
   * @return {Promise<void>}
   * @private
   */
  async _changeMailingFieldsState(disabled: boolean) {
    if (disabled) {
      this.statesMailing = this.states;
      this.formGroup.controls['mailingStreet1'].reset({value: this.formGroup.controls['street1'].value, disabled: true});
      this.formGroup.controls['mailingStreet2'].reset({value: this.formGroup.controls['street2'].value, disabled: true});
      this.formGroup.controls['mailingStateProvince'].reset({value: this.formGroup.controls['stateProvince'].value, disabled: true});
      this.formGroup.controls['mailingPostalCode'].reset({value: this.formGroup.controls['postalCode'].value, disabled: true});
      this.formGroup.controls['mailingCity'].reset({value: this.formGroup.controls['city'].value, disabled: true});
      this.formGroup.controls['mailingCountry'].reset({value: this.formGroup.controls['country'].value, disabled: true});
    } else {
      try {
        this.statesMailing = await this.countriesService.getStates(this.business.mailingAddress.country);
      } catch (e) {
        this.close({cancelBtnClicked: false, success: false});
      }
      this.formGroup.controls['mailingStreet1'].reset({value: this.business.mailingAddress.street1, disabled: false});
      this.formGroup.controls['mailingStreet2'].reset({value: this.business.mailingAddress.street2, disabled: false});
      this.formGroup.controls['mailingStateProvince'].reset({value: this.business.mailingAddress.stateProvince, disabled: false});
      this.formGroup.controls['mailingPostalCode'].reset({value: this.business.mailingAddress.postalCode, disabled: false});
      this.formGroup.controls['mailingCity'].reset({value: this.business.mailingAddress.city, disabled: false});
      this.formGroup.controls['mailingCountry'].reset({value: this.business.mailingAddress.country, disabled: false});

      this.formGroup.patchValue({
        mailingStreet1: this.business.mailingAddress.street1,
        mailingStreet2: this.business.mailingAddress.street2,
        mailingStateProvince: this.business.mailingAddress.stateProvince,
        mailingPostalCode: this.business.mailingAddress.postalCode,
        mailingCity: this.business.mailingAddress.city,
        mailingCountry: this.business.mailingAddress.country
      });
    }
  }

  /**
   * called on is same as business address mat checkbox change event.
   * @param {MatCheckboxChange} event
   */
  addressSameChange(event: MatCheckboxChange) {
    this._changeMailingFieldsState(event.source.checked);
  }

  /**
   * changes states dropdown when a different country is chosen.
   * also changes validators depending on whether or states list exists for country
   * @param {string} value
   * @return {Promise<void>}
   * @private
   */
  async _setAddressForm(value: string) {
    this.isLoading = true;
    try {
      this.states = await this.countriesService.getStates(value);
    } catch (e) {
      this.close({cancelBtnClicked: false, success: false});
    }
    this.formGroup.patchValue({stateProvince: ''});
    this.isLoading = false;
    if (!this.states.length) {
      this.formGroup.controls['stateProvince'].setValidators([]);
    } else {
      this.formGroup.controls['stateProvince'].setValidators([Validators.required]);
    }
    this._setPostalCodeValidation(value);
  }

  async _setMailingAddressForm(value: string) {
    this.isLoading = true;
    try {
      this.statesMailing = await this.countriesService.getStates(value);
    } catch (e) {
      this.close({cancelBtnClicked: false, success: false});
    }
    this.formGroup.patchValue({mailingStateProvince: ''});
    this.isLoading = false;
  }

  /**
   * If countryCode is 'US', Postal Code field becomes required.
   * @param {string} countryCode
   * @private
   */
  _setPostalCodeValidation(countryCode: string) {
    if (countryCode === 'US') {
      this.postalCodePlaceHolder = 'Zip Code *';
      this.formGroup.controls['postalCode'].setValidators([
        Validators.required,
        Validators.pattern('^\\d{5}$')
      ]);
      this.formGroup.controls['postalCode'].updateValueAndValidity();
    } else {
      this.postalCodePlaceHolder = 'Postal Code';
      this.formGroup.controls['postalCode'].setValidators([Validators.maxLength(9)]);
      this.formGroup.controls['postalCode'].updateValueAndValidity();
    }
  }

  businessPanelOpened() {
    this.businessPanelText = 'Enter Business Address';
    this.businessPanelIsActive = true;
  }

  businessPanelClosed() {
    this.businessPanelText = 'Expand Business Address Form';
  }

  mailingPanelOpened() {
    this.mailingPanelText = 'Enter Mailing Address';
    this.businessPanelIsActive = false;
    if (this.formGroup.controls['addressSame'].value) {
      this._changeMailingFieldsState(true);
    }
  }

  mailingPanelClosed() {
    this.mailingPanelText = 'Expand Mailing Address Form';
  }

  /**
   * formats passed in phone number string;
   * @param {string} field
   * @param {string} value
   * @return {string}
   */
  formatPhoneNumber (field: string, value: string): string {
    const NEW_NUMBER: string = formatPhoneString(value);
    this.formGroup.patchValue({[field]: NEW_NUMBER});
    return NEW_NUMBER;
  }

  /**
   * event triggered by keyup event on phone number or fax fields
   * @param event
   * @param {string} field
   * @param phoneInputObj
   */
  phoneFieldKeyUp (event, field: string, phoneInputObj) {
    const value: string = this.formGroup.get(field).value;
    const rawValue = undoPhoneFormat(value);
    const KEY = event.key;

    if (KEY === 'Backspace' && rawValue.length === 10 && phoneInputObj.selectionStart === rawValue.length) {
      this.formatPhoneNumber(field, value);
    } else if (phoneInputObj.selectionStart < value.length) {
    } else if (KEY === 'Backspace' || KEY === 'ArrowLeft' || KEY === 'ArrowRight') {
      return;
    } else {
      this.formatPhoneNumber(field, value);
    }
  }

  /**
   * triggered when phone number or fax field goes out of focus
   * @param {string} field
   */
  phoneFieldBlur(field: string) {
    const VALUE: string = this.formGroup.get(field).value;
    if (VALUE === '') {
      return;
    }
    this.formatPhoneNumber(field, VALUE);
  }


  isValid(): boolean {
    if (this.formGroup.valid && this.formGroup.controls['terms'].value) {
      return true;
    }
    return false;
  }

  async reloadAirport(identifier: string) {
    this.airport = await this._airportService.getAirport(identifier, true);
  }

  /**
   * closes modal
   */
  close(result = {cancelBtnClicked: true, success: false}) {
    if (result) {
      this._dialogRef.close(result);
    }
  }

  async onSubmit() {

    this.businessTags = [];
    if (this.facilityType === 'Flying Club') {
      this.facilityType = 'FLYING CLUB';
      this.businessTags.push(Object.assign(new BusinessTag(), {tagName: 'Flying Club'}));
    } else if (this.facilityType === 'FBO') {
      this.facilityType = 'BUSINESS';
      this.businessTags.push(Object.assign(new BusinessTag(), {tagName: 'Admin::BusinessIsFbo'}));
    } else if (this.facilityType === 'Flight School') {
      this.facilityType = 'BUSINESS';
      this.businessTags.push(Object.assign(new BusinessTag(), {tagName: 'Flight Training::Certification::Private Pilot'}));
    } else {
      this.facilityType = 'BUSINESS';
    }

    if (this.formGroup.controls['addressSame'].value) {
      this._changeMailingFieldsState(true);
    }

    const CLOSE_DIALOG = new CloseDialog();
    let newBusiness: Business;
    const BUSADDRESS = Object.assign(new Address(), {
      street1: this.formGroup.value.street1,
      street2: this.formGroup.value.street2 || null,
      stateProvince: this.formGroup.value.stateProvince || null,
      postalCode: this.formGroup.value.postalCode || null,
      city: this.formGroup.value.city,
      country: this.formGroup.value.country || null
    });
    const MAILADDRESS = Object.assign(new Address(), {
      street1: this.formGroup.getRawValue().mailingStreet1 || null,
      street2: this.formGroup.getRawValue().mailingStreet2 || null,
      stateProvince: this.formGroup.getRawValue().mailingStateProvince || null,
      postalCode: this.formGroup.getRawValue().mailingPostalCode || null,
      city: this.formGroup.getRawValue().mailingCity || null,
      country: this.formGroup.getRawValue().mailingCountry || null
    });
    const BUSINESS = Object.assign(new NewBusiness(), {
      name: this.formGroup.controls['name'].value,
      facilityType: this.facilityType,
      airport: this.airport,
      businessTags: this.businessTags,
      userAdded: true,
      phone: undoPhoneFormat(this.formGroup.value.phone),
      fax: undoPhoneFormat(this.formGroup.value.fax),
      webAddress: this.formGroup.value.webAddress,
      email: this.formGroup.value.email,
      address: BUSADDRESS,
      mailingAddress: MAILADDRESS
    });

    /*
    // form values are mapped to business object before api call.
    // business address
    this.business.address.street1 = this.formGroup.value.street1;
    this.business.address.street2 = this.formGroup.value.street2 || null;
    this.business.address.stateProvince = this.formGroup.value.stateProvince || null;
    this.business.address.postalCode = this.formGroup.value.postalCode || null;
    this.business.address.city = this.formGroup.value.city;
    this.business.address.country = this.formGroup.value.country || null;
    // mailing address
    this.business.mailingAddress.street1 = this.formGroup.getRawValue().mailingStreet1 || null;
    this.business.mailingAddress.street2 = this.formGroup.getRawValue().mailingStreet2 || null;
    this.business.mailingAddress.stateProvince = this.formGroup.getRawValue().mailingStateProvince || null;
    this.business.mailingAddress.postalCode = this.formGroup.getRawValue().mailingPostalCode || null;
    this.business.mailingAddress.city = this.formGroup.getRawValue().mailingCity || null;
    this.business.mailingAddress.country = this.formGroup.getRawValue().mailingCountry || null;
    // contact info & web address
    this.business.phone = undoPhoneFormat(this.formGroup.value.phone);
    this.business.fax = undoPhoneFormat(this.formGroup.value.fax);
    this.business.webAddress = this.formGroup.value.webAddress;
    this.business.email = this.formGroup.value.email;
  */

    // api call
    try {
      this.isLoading = true;
      newBusiness = await this._businessManagerService.createBusiness(BUSINESS);
      await this._userService.saveAcceptedTermsAndPrivacy();
      this.isLoading = false;
      CLOSE_DIALOG.payload = newBusiness.id;
      CLOSE_DIALOG.success = true;
      let type = 'business';
      if (this.facilityType === 'FLYING CLUB') {
        type = 'flyingclub';
      }
      this._router.navigateByUrl(`/${type}/${newBusiness.id}`);
    } catch (e) {
      CLOSE_DIALOG.success = false;
      if (e) {
        CLOSE_DIALOG.error = e;
      }
    }
    this._dialogRef.close(CLOSE_DIALOG);
  }

}
